import { Component } from '@angular/core';
import { IToolbarItem } from '@shared/interfaces/toolbar-item.interface';

@Component({
  selector: 'app-toolbar-activities',
  templateUrl: './toolbar-activities.component.html',
  styleUrls: ['./toolbar-activities.component.scss']
})
export class ToolbarActivitiesComponent {
  public toolbarMenuItems: Array<IToolbarItem> = [
    {
      icon: 'assets/icons/icon_home.png',
      title: 'INICIO',
      route: '/panel/dashboard',
      color: '#FFFFFF'
    },
    {
      icon: 'assets/icons/icon_bookings.png',
      title: 'RESERVAS',
      route: '/panel/bookings',
      color: '#FFFFFF'
    },
    {
      icon: 'assets/icons/icon_cash.png',
      title: 'CAJA',
      route: '/panel/payments',
      color: '#FFFFFF'
    },
    {
      icon: 'assets/icons/icon_planning.png',
      title: 'PLANNING',
      route: '/panel/planning',
      color: '#FFFFFF'
    },
    {
      icon: 'assets/icons/icon_inventory.png',
      title: 'INVENTARIOS',
      route: '/panel/inventories',
      color: '#FFFFFF'
    }
  ];

}
